import React from 'react';
import { COLOR } from '../../styles';
import { type SVGProps } from './SVG.types';

export const Remove: React.FC<SVGProps> = ({
  color = COLOR['black'],
  height = '14px',
  width = '14px',
}) => (
  <svg
    className="icon icon-add"
    width={width}
    height={height}
    viewBox="0 0 14 14"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-5.000000, -5.000000)">
        <polygon
          fill={color}
          transform="rotate(-45 12 12)"
          fillRule="nonzero"
          points="19 13 13 13 13 19 11 19 11 13 5 13 5 11 11 11 11 5 13 5 13 11 19 11"
        ></polygon>
      </g>
    </g>
  </svg>
);

// Display Name
Remove.displayName = 'Remove';

export default Remove;
